"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleValues = handleValues;
exports.pipeValue = pipeValue;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var MAX_DATE_VALUES = {
  dd: 31,
  mm: 12,
  yyyy: 2019
};
var DATE_FORMAT = 'mm / dd / yyyy';
var MAX_DAYS_IN_MONTH = {
  '01': 31,
  '02': 29,
  '03': 31,
  '04': 30,
  '05': 31,
  '06': 30,
  '07': 31,
  '08': 31,
  '09': 30,
  '10': 31,
  '11': 30,
  '12': 31
};
/**
 * Computes a set of values based on the "nextValue"
 * @param {String} nextValue user input value
 * @return {Object} object with "rawValue", "formattedValue", and "maskedValue" computed
 */

function handleValues(nextValue) {
  // Replace all spaces and forward slashes
  var rawDate = nextValue.split(' / ');
  var rawValue = {
    month: rawDate[0],
    day: rawDate[1],
    year: rawDate[2]
  };
  return {
    rawValue: rawValue,
    formattedValue: nextValue
  };
}
/**
 * Determines whether or not the input year is considered a leap year
 * @param {String} year full 4 digit year
 * @return {Boolean} boolean value of whether or not the year is a leap year
 */


function leapYear(year) {
  if (Number(year) % 4 !== 0) return false;
  if (Number(year) % 100 === 0 && Number(year) % 400 !== 0) return false;
  return true;
}
/**
 * Determines the validity of a date in array form based on month, day, and year
 * The expected date format will be a single string
 * @param {String[]} date formatted as an array of single strings per index
 * @return {Boolean} if the date is invalid, returns true; otherwise, returns false
 */


function isInvalid(date, placeholderChar) {
  var month = date.slice(0, 2).join('');
  var day = date.slice(5, 7).join('');
  var year = date.slice(10).join('');
  var fullYear = year.trim().replace(placeholderChar, '').length === 4; // Handle month

  if (date[0] === '0' && date[1] === '0') return true;
  if (parseInt(date[0], 10) === 1 && parseInt(date[1], 10) > 2) return true; // Handle days

  if (date[5] === '0' && date[6] === '0') return true;
  if (parseInt(date[5], 10) === 3 && parseInt(date[6], 10) > 1) return true;
  if (parseInt(day, 10) > MAX_DAYS_IN_MONTH[month]) return true; // Handle Years

  if (parseInt(date[10], 10) === 2) {
    if (parseInt(date[11], 10) > 0) return true;
    if (parseInt(date[12], 10) > 1) return true;
  }

  if (parseInt(date[10], 10) === 1) {
    if (parseInt(date[11], 10) < 9) return true;
  } // Start checking for leap years if the input year is a full 4 digit year


  if (fullYear) {
    // Prevent final digit in the year to be entered if it is not a valid leap year and the day is February 29
    if (!leapYear(year) && parseInt(month, 10) === 2 && parseInt(day, 10) === 29) return true;
  }

  return false;
}
/**
 * Formats the day for February
 * @param {String[]} date
 * @return {Object} returns an object with updated date values and an array of indexes that were modified
 */


function formatFebruary(date) {
  var conformedValues = _toConsumableArray(date);

  var pipedIndexes = []; // Add a 0 in front of the user input if the first digit entered is a 3

  if (parseInt(conformedValues[5], 10) === 3) {
    var prevDayFirstDigit = conformedValues[5];
    conformedValues[6] = prevDayFirstDigit;
    conformedValues[5] = '0';
    pipedIndexes.push(5);
  }

  return {
    conformedValues: conformedValues,
    pipedIndexes: pipedIndexes
  };
}
/**
 * Modifies the user input value before sending it to the input field as the value
 * @param {Object} prevState the previous state of the input field values; currently unused
 * @param {String} conformedValue user input value before we send it as value to the input field
 */


function pipeValue(conformedValue) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var placeholderChar = config.placeholderChar;
  var indexesOfPipedChars = [];
  var dateParts = DATE_FORMAT.split(' / ');
  var conformedValueArr = conformedValue.split(''); // If the first digit entered for a year is 0 or above 2, insert a 19 prefix and append the user input

  if (parseInt(conformedValueArr[10], 10) > 2 || parseInt(conformedValueArr[10], 10) === 0) {
    var prevYearFirstDigit = conformedValueArr[10];
    conformedValueArr[12] = prevYearFirstDigit;
    conformedValueArr[11] = '9';
    conformedValueArr[10] = '1';
    indexesOfPipedChars.push(10, 11);
  } // Format special cases for February


  if (conformedValueArr.slice(0, 2).join('') === '02') {
    var _formatFebruary = formatFebruary(conformedValueArr, indexesOfPipedChars),
        conformedValues = _formatFebruary.conformedValues,
        pipedIndexes = _formatFebruary.pipedIndexes;

    conformedValueArr = conformedValues;
    indexesOfPipedChars = indexesOfPipedChars.concat(pipedIndexes);
  } // Update month and day with 0s if the user's first digit exceeds allowable max


  dateParts.forEach(function (format) {
    var position = DATE_FORMAT.indexOf(format);
    var maxFirstDigit = parseInt(MAX_DATE_VALUES[format].toString().substr(0, 1), 10); // Add 0s in front of the month or day if it exceeds the max digit

    if (parseInt(conformedValueArr[position], 10) > maxFirstDigit) {
      conformedValueArr[position + 1] = conformedValueArr[position];
      conformedValueArr[position] = 0;
      indexesOfPipedChars.push(position);
    }
  });

  if (isInvalid(conformedValueArr, placeholderChar)) {
    return false;
  }

  return {
    value: conformedValueArr.join(''),
    indexesOfPipedChars: indexesOfPipedChars
  };
}
